var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_835_2563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8099 2.56982H2.09076C1.40196 2.56982 0.843567 3.12821 0.843567 3.81702V14.4182C0.843567 15.107 1.40196 15.6654 2.09076 15.6654H15.8099C16.4987 15.6654 17.0571 15.107 17.0571 14.4182V3.81702C17.0571 3.12821 16.4987 2.56982 15.8099 2.56982Z",
    stroke: "white",
    strokeWidth: 1.2472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.843384 4.12891L8.15195 10.3649C8.37605 10.5515 8.65849 10.6538 8.95015 10.6538C9.24181 10.6538 9.52425 10.5515 9.74836 10.3649L17.0569 4.12891",
    stroke: "white",
    strokeWidth: 1.2472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_835_2563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4607,
    height: 17.4607,
    fill: "white",
    transform: "translate(0.21991 0.387207)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.8f1e9632a358be957c32a2287a90d727.svg";
export { ForwardRef as ReactComponent };